import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";

@Form({ title: "The Academy Credit Config" })
export default class TheAcademyCreditConfig {
    @Input({ type: InputType.CHECKBOX, title: "Enable Year Filter" })
    public enableYearFilter?: boolean;

    @Input({ type: InputType.JSON, title: "Credit Claim Params" })
    public creditClaimParams?: object;

}


// WEBPACK FOOTER //
// ./src/panels/creditSummary/TheAcademyCreditConfig.ts